import client from "./axiosConfig";

export const getAllMaterials = (id, params) => {
  const config = {
    url: `/projects/${id}/materials/`,
    method: "GET",
    params
  };
  const response = client(config);
  return response;
};

export const getMaterialById = (projectId, materialId) => {
  const config = {
    url: `/projects/${projectId}/materials/${materialId}/`,
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const updateMaterialById = (projectId, materialId, data) => {
  
  const config = {
    url: `/projects/${projectId}/materials/${materialId}/`,
    method: "PATCH",
    data
  };
  const response = client(config);
  return response;
};

export const bulkMaterialUpdate = (projectId, data) =>
{
  const config = {
    url: `/projects/${projectId}/materials/bulk-update-status/`,
    method: "PATCH",
    data
      
  }
  const response = client(config);
  return response;
}

export const uploadMaterialExcel = (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const config = {
    url: `/projects/import-material-excel/`,
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  return client(config);
};



export const addProjectMaterial = (projectId, data) => {
  const config = {
    url: `/projects/${projectId}/materials/`,
    method: 'POST',
    data,
  }
  const response = client(config);
  return response;
}


export const deleteMaterialById = (projectId, materialId) => {
  const config = {
    url: `/projects/${projectId}/materials/${materialId}/`,
    method: "DELETE",
  };
  const response = client(config);
  return response;
};
